import {
	GetResourceResponseDto,
	Library,
	ResourceDTO,
} from "@onair/repositories";
import { create } from "zustand";

interface IUploads {
	id: string;
	referencedId?: string;
	href?: string;
	uploading: boolean;
	percent: number;
}

enum LibraryTabEnum {
	DOCUMENT = "document",
	LINK = "link",
}

export interface IStoreLibrary {
	isOpen: boolean;
	rootLibraryId: string;
	tab: LibraryTabEnum;
	resources: string[];
	uploads: IUploads[];
	isMultiple: boolean;
	selectResourceId: string;
	currentOwnerId?: string;
	selectedResourceItems: GetResourceResponseDto[];
	callback: (data: any) => void;
	setIsOpen: ({
		isOpen,
		callback,
		isMultiple,
		selecteds,
		ownerId,
	}: {
		isOpen: boolean;
		callback?: (data: any) => void;
		isMultiple?: boolean;
		selecteds?: string[];
		ownerId?: string;
	}) => void;
	setResources: (resources: string[]) => void;
	setRootLibraryId: (rootLibraryId: string) => void;
	handleSelectResourceId: (id: string) => void;
	handleSelectIsMultiple: (resources: string[]) => void;
	handleUpload: () => void;
	handleDeleteUpload: (id: string) => void;
	handleDeleteResource: (id: string) => void;
	setCurrentOwnerId: (ownerId?: string) => void;
	onOpenResource?: (options: {
		isMultiple?: boolean;
		selecteds?: string[];
		onSelection?: (items: GetResourceResponseDto[]) => void;
	}) => void;
	confirmSelectResourceItems?: (items: GetResourceResponseDto[]) => void;
	setSelectedResourceItems?: (items: GetResourceResponseDto[]) => void;
}

const initialState: IStoreLibrary = {
	isOpen: false,
	rootLibraryId: "",
	resources: [],
	callback: () => {},
	uploads: [],
	selectResourceId: "",
	isMultiple: false,
	currentOwnerId: undefined,
	tab: LibraryTabEnum.DOCUMENT,
	selectedResourceItems: [],
	handleUpload: () => {},
	setResources: (resources: string[]) => {},
	setIsOpen: ({
		isOpen,
		callback,
		isMultiple,
		selecteds,
		ownerId,
	}: {
		isOpen: boolean;
		callback?: (data: any) => void;
		isMultiple?: boolean;
		selecteds?: string[];
		ownerId?: string;
	}) => {},
	setRootLibraryId: (rootLibraryId: string) => {},
	handleSelectResourceId: () => {},
	handleSelectIsMultiple: (resources: string[]) => {},
	handleDeleteUpload: () => {},
	handleDeleteResource: () => {},
	setCurrentOwnerId: (ownerId: string) => {},
};

export const useStoreLibrary = create<IStoreLibrary>((set, get) => ({
	...initialState,
	setIsOpen: ({
		isOpen,
		callback,
		isMultiple,
		selecteds,
		ownerId,
	}: {
		isOpen: boolean;
		callback?: (data: any) => void;
		isMultiple?: boolean;
		selecteds?: string[];
		ownerId?: string;
	}) =>
		set({
			isOpen,
			callback,
			isMultiple,
			resources: selecteds || [],
			currentOwnerId: ownerId,
		}),

	setRootLibraryId: (rootLibraryId: string) => {
		set({ rootLibraryId });
	},

	setResources: (resources: string[]) => {
		set({ resources });
	},
	handleUpload: () => {
		const uploads = get().uploads;
		const newUploads = uploads.map((upload) => {
			if (upload.uploading) {
				return upload;
			}
			return {
				...upload,
				uploading: true,
			};
		});
		set({ uploads: newUploads });
	},
	handleDeleteUpload: (id) => {
		const uploads = get().uploads;
		const newUploads = uploads.filter((upload) => upload.id !== id);
		set({ uploads: newUploads });
	},
	handleDeleteResource: (id) => {
		const uploads = get().uploads;
		const newUploads = uploads.filter((upload) => upload.referencedId !== id);
		set({ uploads: newUploads });
	},
	handleSelectResourceId: (id) => {
		set({ selectResourceId: id });
	},
	handleSelectIsMultiple: (resources: string[]) => {
		set({ resources });
	},
	setCurrentOwnerId: (ownerId?: string) => {
		set({ currentOwnerId: ownerId });
	},
	onOpenResource: ({ isMultiple, selecteds, onSelection }) =>
		set({
			isMultiple,
			isOpen: true,
			resources: selecteds ? selecteds : [],
			confirmSelectResourceItems: onSelection,
		}),

	setSelectedResourceItems: (items) => {
		set({
			selectedResourceItems: items,
		});
	},
}));
